import React, { Component } from 'react';
import './Badge.css';
import PropTypes from 'prop-types';

class Badge extends Component {
  constructor(props) {
    super(props);
    this.label = props.label;
    this.isVeryNewReport = props.isVeryNewReport;
  }

  render() {
    if (this.isVeryNewReport) {
      return <span className="badge badge-secondary badge-customised-very-new badge-text">{this.label}</span>;
    }
    return <span className="badge badge-secondary badge-customised badge-text">{this.label}</span>;
  }
}

export default Badge;

Badge.propTypes = {
  label: PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./src/Components/Badge/Badge.js